import { CONF } from '../constants';

/**
 *
 * @param {any} data
 * @param {object} filters
 * @param {boolean} sort
 * @returns
 */
export function processResponse(response = {}, filters, sort) {
  const { config, data = {} } = response;
  let { data: values, total } = data;
  const [resource] = (config?.url || '').split('?');

  if (values === null || values === undefined) {
    values = [];
  }

  if (typeof values === 'string') {
    if (values.startsWith('EXCEPTION:')) {
      throw new Error(values);
    }

    try {
      values = JSON.parse(values);
    } catch (e) {
      values = [];
    }
  }

  const {
    getById = true,
    sort: defaultSort,
  } = CONF[resource] || {};

  if ('id' in filters && getById) {
    const result = Array.isArray(values) ? values[0] : values;

    return result;
  }

  const sortCriteria = sort || defaultSort;
  if (sortCriteria) {
    values.sort((a, b) => a[sortCriteria] - b[sortCriteria]);
  }

  if (!total) {
    total = 0;
  }

  return {
    values,
    total,
  };
}
